angular.module('lf.desktop')

.directive('popover', function ($parse, popoversService) {
  return {
    restrict: 'EA',
    transclude: true,
    link: function (scope, el, attrs, ctrl, transclude) {
      var popover = {
        name: attrs.popover
      }
      var popoverOptions = $parse(attrs.popoverOptions)(scope);

      var defaults = {
        hideDelay: 500,
        fadeInDuration: 200,
        fadeOutDuration: 200,
        fadeInEasing: 'easeOutQuad',
        fadeOutEasing: 'easeInQuad',
        marginTop: 10,
        boundaries: '.navbar .container'
      };
      
      var opts = _.extend({}, defaults, popoverOptions);
      
      if (!popover.name) {
        throw new Error('Popover should have `name` (e.g. popover="hello")');
      }
      
      var tmpl = [
        '<div class="ui-popover__container">',
          '<div class="ui-popover__pointer"></div>', 
          '<div class="ui-popover__modal"></div>',
        '</div>'
      ].join('');

      popover.$container = angular.element(tmpl);
      
      popover.$container.attr('data-popover-name', popover.name);
      
      _.extend(popover, {
        $pointer: popover.$container.find('.ui-popover__pointer'),
        $modal: popover.$container.find('.ui-popover__modal')
      });
      
      transclude(scope, function (clone) {
        popover.$modal.append(clone);
        el.remove();
      });
      
      if (opts.className) {
        popover.$modal.addClass(opts.className);
      }
      
      $('body').append(popover.$container);
      
      scope.$on('popover:bind', function (e, args) {
        if (args.name !== popover.name) return;
        var $trigger = popover.$trigger = args.el;
        
        $trigger
          .on('mouseenter', show)
          .on('mouseleave', hide.bind(null, opts.hideDelay));
      });
      
      popover.$container.on('mouseenter', function () {
        clearTimeout(popover._hideTimeout);
      });
      
      popover.$container.on('mousemove', function () {
        clearTimeout(popover._hideTimeout);
      });
      
      popover.$container.on('mouseleave', function () {
        popover._hideTimeout = setTimeout(hide, opts.hideDelay);
      });
      
      scope.$on('popover:show', function (e, args) {
        if (args.name !== popover.name) return;
        if (args.hideDelay) {
          show({hideDelay: args.hideDelay});
        } else {
          show();
        }
      });
      
      scope.$on('popover:hide', function (e, args) {
        if (args.name !== popover.name) return;
        if (args.immediately) {
          hide(null, true);
        } else {
          hide();
          
        }
      });
      
      function show (showOpts) {
//        console.log('popover show pre', popover.name, popover.visible, popover._animating);
        clearTimeout(popover._hideTimeout);

        if (popover.visible || popover._animating) {
          if (popover._animating === 'hide') {
            popover.$container
              .velocity('stop')
              .velocity('reverse');
          }
          if (showOpts.hideDelay) {
            popover._hideTimeout = setTimeout(hide, showOpts.hideDelay);
          }
          return;
        }
        
//        console.log('popover show post', popover.name);
        popoversService.hideAll({except: popover.name, immediately: true});
        
        var containerPosition = popover.$container.css('position');
        var triggerOffset = popover.$trigger.offset();
        var dimensions = getElementDimensions(popover.$container);
        var windowScrollY = window.scrollY ||
                            window.pageYOffset ||
                            document.documentElement && document.documentElement.scrollTop ||
                            document.body && (document.body.scrollTop || document.body.parentNode.scrollTop) ||
                            0;
        
        _.extend(popover, {
          width: dimensions.width,
          height: dimensions.height,
          top: (
            triggerOffset.top 
            - (containerPosition === 'absolute' ? 0 : windowScrollY) 
            + popover.$trigger.outerHeight() 
            + opts.marginTop
          ) | 0
        });
        
        popover.left = (triggerOffset.left + (popover.$trigger.outerWidth() / 2) - (popover.width / 2)) | 0;
        popover.marginX = 0;
        
        if (opts.boundaries) {
          var boundaries = {};
          var $boundaries = $(opts.boundaries);
          var marginX = 0;
          
          if (!$boundaries.length) {
            console.warn('Popover "%s": can not find boundary element "%s"', popover.name, opts.boundaries);
          } else {
            // Currently we handle only horizontal right boundary case
            boundaries.right = ($boundaries.offset().left + $boundaries.outerWidth()) | 0;
            marginX = (boundaries.right - (popover.left + popover.width)) | 0;
            popover.marginX = marginX < 0 ? marginX : 0;
          }
        }
        
        popover.$pointer.css({
          left: (popover.width / 2 | 0) - (popover.$pointer.outerWidth() / 2 | 0) - popover.marginX
        });
        
        popover.$container
          .css({
            top: popover.top + 20,
            left: popover.left + popover.marginX,
            opacity: 0,
            zIndex: popoversService.nextZIndex++
          })
          .velocity('stop')
          .velocity({
            top: popover.top,
            opacity: 1,
          }, {
            duration: opts.fadeInDuration,
            easing: opts.fadeInEasing,
            display: 'block',
            begin: function () {
              popover.visible = true;
              popover._animating = 'show';
            },
            complete: function () {
              popover._animating = false;
              if (showOpts.hideDelay) {
                popover._hideTimeout = setTimeout(hide, showOpts.hideDelay);
              }
            }
          });
        
        attachDocumentClickHandler();
      }
      
      popoversService.register(popover.name);
      
      function hide (hideDelay, immediately) {
        clearTimeout(popover._hideTimeout);
        
        if (_.isBoolean(immediately) && immediately) {
          popover.$container
            .velocity('stop')
            .hide();
          popover.visible = false;
          popover._animating = false;
          detachDocumentClickHandler();
          return;
        }

        if (!popover.visible) {
          return;
        }
        
        if (hideDelay) {
          popover._hideTimeout = setTimeout(hide, hideDelay);
        } else {
          popover.$container
            .velocity('stop')
            .velocity({
              top: popover.top + 20,
              opacity: 0
            }, {
              duration: opts.fadeOutDuration,
              easing: opts.fadeOutEasing,
              display: 'none',
              begin: function () {
                popover._animating = 'hide';
              },
              complete: function () {
                popover.visible = false;
                popover._animating = false;
                detachDocumentClickHandler();
              }
            });
        }
      }
      
      function getElementDimensions (el) {
        var dimensions = {};
        var isHidden = el.is(':hidden');
        
        if (isHidden) {
          el.css({
            position: 'fixed',
            top: -1e6,
            left: -1e6,
            visibility: 'hidden',
            display: 'block'
          });
        }

        dimensions.width = el.outerWidth();
        dimensions.height = el.outerHeight();

        if (isHidden) {
          el.css({
            position: '',
            top: '',
            left: '',
            visibility: '',
            display: ''
          });
        }
        
        return dimensions;
      }
      
      function attachDocumentClickHandler () {
        $(document)
          .off('click.popover-document-click-handler touchstart.popover-document-click-handler')
          .on('click.popover-document-click-handler touchstart.popover-document-click-handler', function (e) {
            if ($(e.target).closest('.ui-popover__container').length) return;
            hide();
          });
      }
      
      function detachDocumentClickHandler () {
        $(document).off('click.popover-document-click-handler touchstart.popover-document-click-handler');
      }

      scope.$on('$destroy', function () {
        popoversService.unregister(popovers.name);
        popover.$container.hide();
        popover.$container.off('mouseenter');
        popover.$container.off('mouseleave');
        popover.$trigger.off('mouseenter');
        popover.$trigger.off('mouseleave');
        popover.$trigger = null;
        popover.$container = null;
        popover = null;
        opts = null;
        detachDocumentClickHandler();
      });
      
    }
  }
});
